import { RouteConfig } from "vue-router";

export const RGuideBrowse: RouteConfig = {
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "guide-browse" */
      "./VGuideBrowse.vue"
    ),
  meta: {
    title: "Guide",
  },
};

export const RExpertGuideBrowse: RouteConfig = {
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "expert-guide-browse" */
      "./VExpertGuideBrowse.vue"
    ),
  meta: {
    title: "Guide",
  },
};
